import { CountriesEnum } from 'Rentlio/utils/countriesEnum'

const getCountryDialCode = countryCode => {
  if (!countryCode) return ''
  const countryDialCode = CountriesEnum.find(country => country.code === countryCode)
  return countryDialCode ? countryDialCode.dial_code : ''
}

export default getCountryDialCode
